import React from 'react';
import { SalesFansData } from './types';
import { getStatusLabels } from './constants';

export const getStatusLabel = (status: string, t: any): string => {
  const labels = getStatusLabels(t);
  return labels[status as keyof typeof labels] || status;
};

export const formatPrice = (amount: number, currency: string = 'USD'): string => {
  return `$${amount?.toFixed(2)}`;
};

export const formatFansRange = (min: number, max: number | null, perDay: number): string => {
  const range = max ? `${min}-${max}` : `${min}+`;
  return `${range} /~${perDay} в день`;
};

export const formatTimeAgo = (dateString: string): string => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();

  if (diffInMs < 0) {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

  if (diffInDays > 0) {
    return `${diffInDays}д. назад`;
  } else if (diffInHours > 0) {
    return `${diffInHours}ч. назад`;
  } else if (diffInMinutes > 0) {
    return `${diffInMinutes}мин. назад`;
  }
  return 'только что';
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-800';
    case 'inactive':
      return 'bg-gray-100 text-gray-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'suspended':
      return 'bg-red-100 text-red-800';
    case 'moderation':
      return 'bg-purple-100 text-purple-800';
    case 'hidden':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getStatusDotColor = (status: string): string => {
  switch (status) {
    case 'active':
      return 'bg-success';
    case 'inactive':
      return 'bg-gray-500';
    case 'pending':
      return 'bg-yellow-500';
    case 'suspended':
      return 'bg-red-500';
    case 'moderation':
      return 'bg-accent';
    case 'hidden':
      return 'bg-auth-strength-weak';
    default:
      return 'bg-gray-500';
  }
};
